import { css, keyframes } from '@sitebase/emotion';

var rotate = /*#__PURE__*/keyframes('0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}');

export var spinnerWrapper = /*#__PURE__*/css('animation:', rotate, ' 1s linear infinite;box-sizing:border-box !important;display:inline-flex;outline:none;position:relative;user-select:none;');

export var spinner = /*#__PURE__*/css('animation:', rotate, ' 1.5s linear infinite;animation-play-state:paused;animation-fill-mode:both;&:hover{animation-play-state:running;}');

var _ref = 'width:';
var _ref2 = 'px;height:';
var _ref3 = 'px;';
export var getDimensionsStyle = function getDimensionsStyle(size) {
  return (/*#__PURE__*/css(_ref, size, _ref2, size, _ref3)
  );
};

var _ref4 = 'position:absolute;left:-';
var _ref5 = 'px;top:-';
var _ref6 = 'px;';
export var getAlignmentStyle = function getAlignmentStyle(padding) {
  return (/*#__PURE__*/css(_ref4, padding, _ref5, padding, _ref6)
  );
};